export const domainToURL = (domain: string) => {
  if (!domain.startsWith('http')) domain = `https://${domain}`;
  return new URL('/', domain).origin;
};
